// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../../node_modules/postcss-loader/dist/cjs.js!../../../../components/library/style/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.F9fXLiFaA_BVMC63B8hG {
    display: flex;
    align-items: center;
    column-gap: 8px;
}

.Rzmf75dgFCwDXsRgAcND {
    width: 42px;
    height: 42px;
    border-radius: 42px;

    background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple-bg"]};
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]};

    display: flex;
    justify-content: center;
    align-items: center;
}

.Rzmf75dgFCwDXsRgAcND svg {
    font-size: 16px;
}

.SvRv_2XPOcuRFnhKiT3D, .QE6ayevjHYtGNxblemG3 {
    margin: 0;
}

.SvRv_2XPOcuRFnhKiT3D {
    font-size: 14px;
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text-subtle"]};
}

.QE6ayevjHYtGNxblemG3 {
    font-weight: 500;
}

.kw27oe3ABsgUbjDwv5ZN .Rzmf75dgFCwDXsRgAcND, .kw27oe3ABsgUbjDwv5ZN .SvRv_2XPOcuRFnhKiT3D {
    background: #e2e2e2;
    border: none;
    color: transparent;
    position: relative;
    overflow: hidden;
}

.kw27oe3ABsgUbjDwv5ZN .SvRv_2XPOcuRFnhKiT3D {
    width: 100px;
    height: 18px;
    margin-top: 8px;
}

.kw27oe3ABsgUbjDwv5ZN .Rzmf75dgFCwDXsRgAcND::before,
.kw27oe3ABsgUbjDwv5ZN .SvRv_2XPOcuRFnhKiT3D::before {
    content: "";
    position: absolute;
    left: -50%;
    top: 0;
    height: 100%;
    width: 100%;
    background: linear-gradient(to right, #e2e2e2 25%, #d3d3d3 50%, #e2e2e2 100%);
    animation-name: qMMMNCDWTOcOBSyhG4_R;
    animation-duration: 2s;
    animation-iteration-count: infinite;
    filter: blur(5px);
}

@keyframes qMMMNCDWTOcOBSyhG4_R {
    from {
        left: -50%;
    }
    to {
        left: 100%;
    }
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/DashboardWallet/DashboardWalletData/DashboardWalletData.module.css"],"names":[],"mappings":"AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;;IAEnB,8DAAiC;IACjC,mDAAmB;;IAEnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,eAAe;IACf,mDAAwB;AAC5B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;AACnB;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,MAAM;IACN,YAAY;IACZ,WAAW;IACX,6EAA6E;IAC7E,oCAAkC;IAClC,sBAAsB;IACtB,mCAAmC;IACnC,iBAAiB;AACrB;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ","sourcesContent":["@value colors: \"../../../../components/library/style/colors.css\";\n@value color-purple-bg, color-purple, color-text-subtle from colors;\n\n.container {\n    display: flex;\n    align-items: center;\n    column-gap: 8px;\n}\n\n.icon {\n    width: 42px;\n    height: 42px;\n    border-radius: 42px;\n\n    background-color: color-purple-bg;\n    color: color-purple;\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.icon svg {\n    font-size: 16px;\n}\n\n.label, .data {\n    margin: 0;\n}\n\n.label {\n    font-size: 14px;\n    color: color-text-subtle;\n}\n\n.data {\n    font-weight: 500;\n}\n\n.skeleton .icon, .skeleton .label {\n    background: #e2e2e2;\n    border: none;\n    color: transparent;\n    position: relative;\n    overflow: hidden;\n}\n\n.skeleton .label {\n    width: 100px;\n    height: 18px;\n    margin-top: 8px;\n}\n\n.skeleton .icon::before,\n.skeleton .label::before {\n    content: \"\";\n    position: absolute;\n    left: -50%;\n    top: 0;\n    height: 100%;\n    width: 100%;\n    background: linear-gradient(to right, #e2e2e2 25%, #d3d3d3 50%, #e2e2e2 100%);\n    animation-name: gradient-animation;\n    animation-duration: 2s;\n    animation-iteration-count: infinite;\n    filter: blur(5px);\n}\n\n@keyframes gradient-animation {\n    from {\n        left: -50%;\n    }\n    to {\n        left: 100%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `"../../../../components/library/style/colors.css"`,
	"color-purple-bg": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple-bg"]}`,
	"color-purple": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]}`,
	"color-text-subtle": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text-subtle"]}`,
	"container": `F9fXLiFaA_BVMC63B8hG`,
	"icon": `Rzmf75dgFCwDXsRgAcND`,
	"label": `SvRv_2XPOcuRFnhKiT3D`,
	"data": `QE6ayevjHYtGNxblemG3`,
	"skeleton": `kw27oe3ABsgUbjDwv5ZN`,
	"gradient-animation": `qMMMNCDWTOcOBSyhG4_R`
};
export default ___CSS_LOADER_EXPORT___;
